import type { BranchPrintSettingsNormalized } from 'store/posStore'

export const ALLOW_UNPAID_TAKEAWAY_KITCHEN_PRINT = 'allow_unpaid_takeaway_kitchen_print'

function parseOptInFlag(value: unknown): boolean {
  if (value === true || value === 1 || value === '1') return true
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase()
    return normalized === 'true' || normalized === 'on' || normalized === 'yes'
  }
  return false
}

/** Explicit unpaid-takeaway opt-in. Missing/invalid values never enable. */
export function unpaidTakeawayKitchenOptIn(
  raw: Record<string, unknown> | null | undefined,
): boolean {
  if (!raw || !Object.prototype.hasOwnProperty.call(raw, ALLOW_UNPAID_TAKEAWAY_KITCHEN_PRINT)) {
    return false
  }
  return parseOptInFlag(raw[ALLOW_UNPAID_TAKEAWAY_KITCHEN_PRINT])
}

/**
 * Effective cashier capability. Matches Wave 2A UnpaidTakeawayKitchenPolicy:
 * opt-in AND enable_kitchen_print. Never inferred from unrelated flags.
 */
export function isUnpaidTakeawayKitchenEnabled(
  raw: Record<string, unknown> | null | undefined,
  print?: Pick<BranchPrintSettingsNormalized, 'enable_kitchen_print'>,
): boolean {
  const kitchenEnabled = print?.enable_kitchen_print ?? parseOptInFlag(raw?.enable_kitchen_print)
  return kitchenEnabled && unpaidTakeawayKitchenOptIn(raw)
}

export function isEligibleUnpaidTakeawayCart(params: {
  settings: Record<string, unknown> | null | undefined
  print?: Pick<BranchPrintSettingsNormalized, 'enable_kitchen_print'>
  diningTableId?: string | null
  orderMode?: string | null
}): boolean {
  if (params.diningTableId) return false
  if (params.orderMode && params.orderMode !== 'takeaway') return false
  return isUnpaidTakeawayKitchenEnabled(params.settings, params.print)
}
